export default "__VITE_ASSET__BK19Mhhd__"